<template>
  <div id="RateFeedback" class="feedback-dialog">
    <div class="feedback-dialog-head">
      <i class="el-icon-close" @click="feedbackDialogClose" />
    </div>
    <div v-if="main">
      <span>您对当前品类的选型结果是否满意?</span>
      <el-rate v-model="feedbackRate" :allow-half="true" class="feedback-rate" @change="rateChanged"></el-rate>
      <div v-show="feedbackDescriptionShow" class="feedback-description">
        <span>请描述您的意见或建议:</span>
        <el-input
            type="textarea"
            :rows="3"
            v-model="feedbackDescription"
            class="feedback-description-input">
        </el-input>
      </div>
      <div class="feedback-dialog-bottom">
        <span class="error-tips" v-show="feedbackRateEmpty">请打分后再提交</span>
        <el-button type="primary" :loading="commitLoading" @click="commitFeedback">提交</el-button>
      </div>
    </div>
    <div v-if="feedbackEndDialog" class="feedback-end-dialog" >
      <div>感谢您的反馈。</div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'RateFeedback',
  props: {
    code: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      feedbackRate: 0,
      feedbackDescription: '',
      feedbackRateEmpty: false,
      feedbackEndDialog: false,
      commitLoading: false,
      main: true,
      feedbackDescriptionShow: false,
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/user',
    })
  },
  created() {
    this.$tracks({
      event: 'visitFeedback',
      params: {
        g_c_source: 'Fast_Feedback',
        g_c_class_code: this.code,
        g_c_class_name: this.title
      }
    })
  },
  methods: {
    ...mapActions({
      feedback: 'list/feedback',
      loadUserInfo: 'user/loadUserInfo',
    }),
    rateChanged() {
      if (!this.feedbackDescriptionShow) {
        this.feedbackDescriptionShow = this.feedbackRate && this.feedbackRate <= 4
      }
    },
    async commitFeedback() {
      if (!this.feedbackRate) {
        this.feedbackRateEmpty = true
        return
      }
      const feedBack = {
        title: this.title + ' ' + this.feedbackRate,
        description: this.feedbackDescription ? this.feedbackDescription : '未填写',
        type: this.type
      }
      if (!this.user.mobile) {
        await this.loadUserInfo()
      }
      if (this.user && this.user.mobile) {
        feedBack.mobile = this.user.mobile
      }
      this.commitLoading = true
      await this.feedback(feedBack)
      this.feedbackRate = 0
      this.feedbackDescription = ''
      this.main = false
      this.commitLoading = false
      this.feedbackEndDialog = true
      setTimeout(() => {
        this.$emit('close')
        this.feedbackEndDialog = false
        this.main = true
        this.feedbackDescriptionShow = false
      }, 3000)
    },
    feedbackDialogClose() {
      this.$emit('close')
      this.feedbackRate = 0
      this.feedbackDescription = ''
      this.feedbackRateEmpty = false
      this.feedbackEndDialog = false
      this.main = true
      this.feedbackDescriptionShow = false
    },
  },
}
</script>

<style lang="less" scoped>
  #RateFeedback{
    /deep/ .el-rate__icon{
      font-size: 24px;
      color: #ffffff;
    }
  }
  .feedback-dialog{
    position: fixed;
    width: 280px;
    border-radius: 4px;
    top: 45px;
    right: 18px;
    background: #ffffff;
    border: 1px solid @theme-color;
    box-shadow: 0 0 4px 2px rgba(0,0,0,.25);
    padding: 8px 16px;
    z-index: 999;

    .feedback-dialog-head{
      height: 15px;
      text-align: right;
      margin-bottom: 8px;
      .el-icon-close{
        margin-top: 5px;
        cursor: pointer;
      }
    }

    .feedback-rate{
      margin-top: 8px;
      margin-left: 8px;
    }

    .feedback-description{
      margin-top: 16px;

      .feedback-description-input{
        margin-top: 8px;
      }
    }

    .feedback-dialog-bottom{
      display: flex;
      margin-top: 16px;
      justify-content: flex-end;
      vertical-align: center;

      .error-tips{
        color: #F56C6C;
        margin-right: 10px;
        background-color: #FFEDED;
        white-space: nowrap;
        padding: 5px 10px;
      }
    }

    .feedback-end-dialog{
      padding-bottom: 30px;
    }

  }
</style>
